<template>
  <div>
    <p>{{ schema.$title }}</p>

    <w-input class="mt-3" :model="schema.epuapAddress" />

    <w-input class="mt-3" :model="schema.epuapAddressConfirm" />

    <p class="mt-3">
      Uwaga. Jak znaleźć swój adres elektroniczny ePUAP?
    </p>

    <p>
      Adres elektroniczny znajdziesz na swoim koncie ePUAP. Wejdź na stronę epuap.gov.pl i zaloguj się. Wybierz: Moja
      skrzynka → Operacje → informacje szczegółowe skrzynki (znak plusa) > adres znajduje się w polu lista adresów
      skrytek dla danej skrzynki w formacie /login/nazwaskrzynki.
    </p>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
// @vuese
// Modal podpisywania dokumentu przez EPUAP dla szkoły
// @group ActionData
export default {
  components,
  props: {
    // Schema
    schema: { type: Object, required: true }
  }
};
</script>
